import React, { useState, useEffect } from 'react'
import { Platform, ScrollView, Keyboard, View } from 'react-native'

// Intentamos importar solo en mobile
let MobileKeyboardProvider = null

if (Platform.OS !== 'web') {
    try {
        const lib = require('react-native-keyboard-controller')
        MobileKeyboardProvider = lib.KeyboardProvider
    } catch (e) {
        console.warn('KeyboardProvider no disponible en este entorno:', e)
    }
}

// Wrapper que no rompe en web
export const SafeKeyboardProvider = ({ children }) => {
    if (Platform.OS === 'web' || !MobileKeyboardProvider) {
        return <>{children}</>
    }

    return (
        <MobileKeyboardProvider statusBarTranslucent>
            {children}
        </MobileKeyboardProvider>
    )
}

let KeyboardAvoidingViewController = null

// Intento de import seguro solo en iOS/Android
if (Platform.OS !== 'web') {
    try {
        const lib = require('react-native-keyboard-controller')
        KeyboardAvoidingViewController = lib.KeyboardAvoidingView
    } catch (e) {
        console.warn('KeyboardAvoidingView (controller) no disponible:', e)
    }
}

export const SafeKeyboardControllerAvoidingView = ({ children, style, ...rest }) => {
    // WEB → no usar nada
    if (Platform.OS === 'web' || !KeyboardAvoidingViewController) {
        return <>{children}</>
    }

    // Mobile → usar el componente REAL
    return (
        <KeyboardAvoidingViewController style={style} {...rest}>
            {children}
        </KeyboardAvoidingViewController>
    )
}

let MobileKeyboardAvoidingView = null

if (Platform.OS !== 'web') {
    try {
        const lib = require('react-native-keyboard-controller')
        MobileKeyboardAvoidingView = lib.KeyboardAvoidingView
    } catch (e) {
        console.warn('KeyboardAvoidingView no disponible:', e)
    }
}

export const SafeKeyboardAvoidingView = ({ children, style, ...rest }) => {
    // En web o si no se pudo cargar la lib → View común
    if (Platform.OS === 'web' || !MobileKeyboardAvoidingView) {
        return (
            <View style={style} {...rest}>
                {children}
            </View>
        )
    }

    // Mobile con la librería disponible
    return (
        <MobileKeyboardAvoidingView style={style} {...rest}>
            {children}
        </MobileKeyboardAvoidingView>
    )
}

let MobileKeyboardController = null

if (Platform.OS !== 'web') {
    try {
        const lib = require('react-native-keyboard-controller')
        MobileKeyboardController = lib.KeyboardController
    } catch (e) {
        console.warn('KeyboardController no disponible:', e)
    }
}

const fallback = {
    dismiss: () => {},
    setEnabled: () => {},
    setDefaultMode: () => {},
    setKeyboardAnimation: () => {},
}

/**
 * SafeKeyboardController
 * Devuelve siempre un objeto usable
 * En Web → no rompe
 * En Mobile → usa la librería real si está disponible
 */
export const SafeKeyboardController = MobileKeyboardController || fallback

export const useSafeKeyboardOpen = () => {
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        if (Platform.OS === 'web') return

        const showEvent =
            Platform.OS === 'ios' ? 'keyboardWillShow' : 'keyboardDidShow'
        const hideEvent =
            Platform.OS === 'ios' ? 'keyboardWillHide' : 'keyboardDidHide'

        const subShow = Keyboard.addListener(showEvent, () => setIsOpen(true))
        const subHide = Keyboard.addListener(hideEvent, () => setIsOpen(false))

        return () => {
            subShow.remove()
            subHide.remove()
        }
    }, [])

    return isOpen
}

let ScrollAvoidingView = null

if (Platform.OS !== 'web') {
    try {
        ScrollAvoidingView =
            require('react-native-keyboard-controller').ScrollAvoidingView
    } catch (e) {
        console.warn('ScrollAvoidingView no disponible:', e)
    }
}

export const SafeScrollAvoidingView = ({ children, ...props }) => {
    if (ScrollAvoidingView) {
        return <ScrollAvoidingView {...props}>{children}</ScrollAvoidingView>
    }

    // ⚠ WEB → evitar agregar vistas extra
    return <ScrollView>{children}</ScrollView>
}
